import React, { useRef, useState } from "react";
import api, { fileUrl, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Upload, X, ImagePlus } from "lucide-react";

export default function ImageUpload({ value, onChange, label = "Upload image", testId = "image-upload", size = 80, showPreview = true }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd);
      if (!data.url) throw new Error("The server did not return an image URL");
      await onChange(data.url);
      toast.success("Image uploaded");
    } catch (e) {
      toast.error(e.response?.data?.detail ? formatApiError(e.response.data.detail) : e.message || "Upload failed");
    } finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div className="flex items-center gap-3">
      {showPreview && (
        <div
          className="flex items-center justify-center overflow-hidden rounded-xl border border-dashed bg-muted/40"
          style={{ width: size, height: size }}
        >
          {value ? (
            <img src={fileUrl(value)} alt="" className="h-full w-full object-cover" />
          ) : (
            <ImagePlus className="h-6 w-6 text-muted-foreground" />
          )}
        </div>
      )}
      <div className="flex flex-col gap-2">
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testId}-input`} />
        <Button type="button" variant="outline" size="sm" onClick={() => ref.current?.click()} disabled={busy} data-testid={testId}>
          <Upload className="mr-1.5 h-3.5 w-3.5" /> {busy ? "Uploading…" : label}
        </Button>
        {value && (
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange(null)} data-testid={`${testId}-remove`}>
            <X className="mr-1 h-3.5 w-3.5" /> Remove
          </Button>
        )}
      </div>
    </div>
  );
}
